// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ResponseRolloutConditionType = {
  RolloutConditionTypeDeploymentReady: 'DeploymentReady',
  RolloutConditionTypeDeploymentDesired: 'DeploymentDesired',
  RolloutConditionTypeApproved: 'Approved',
  RolloutConditionTypeStepCooldown: 'StepCooldown',
  RolloutConditionTypePaused: 'Paused',
  RolloutConditionTypeTransferring: 'Transferring',
  RolloutConditionTypeAborted: 'Aborted',
  RolloutConditionTypeTransferred: 'Transferred',
  RolloutConditionTypeCompleted: 'Completed',
} as const;
export type ResponseRolloutConditionType =
  (typeof ResponseRolloutConditionType)[keyof typeof ResponseRolloutConditionType];

export function instanceOfResponseRolloutConditionType(value: any): boolean {
  for (const key in ResponseRolloutConditionType) {
    if (
      Object.prototype.hasOwnProperty.call(ResponseRolloutConditionType, key)
    ) {
      if (
        ResponseRolloutConditionType[
          key as keyof typeof ResponseRolloutConditionType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ResponseRolloutConditionTypeFromJSON(
  json: any,
): ResponseRolloutConditionType {
  return ResponseRolloutConditionTypeFromJSONTyped(json, false);
}

export function ResponseRolloutConditionTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseRolloutConditionType {
  return json as ResponseRolloutConditionType;
}

export function ResponseRolloutConditionTypeToJSON(
  value?: ResponseRolloutConditionType | null,
): any {
  return value as any;
}

export function ResponseRolloutConditionTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ResponseRolloutConditionType {
  return value as ResponseRolloutConditionType;
}
